import {axios} from '../../services/axios';

export default function getDRServiceProfileRegions({scope}) {
    return axios.get(
        `/ServiceProfiles/DirectRouting/${scope}/Regions/Available`,
    );
}
